import { useState, useRef, useEffect } from "react";
import './css/GuidedRelapse.css';
import play from './assets/play.png';
import pause from './assets/pause.svg';



const GuidedRelapse = ({ saveAudioBlob, saveAudio, audio }) => {
    const mimeType = "audio/mpeg";
    const [permission, setPermission] = useState(false);
    const mediaRecorder = useRef(null);
    const [playStatus, setPlayStatus] = useState("inactive");
    const [stream, setStream] = useState(null);
    const [audioChunks, setAudioChunks] = useState([]);
    const [audioUrl, setAudioUrl] = useState(null);


    const playBttn = () => {
        //console.log(playStatus)
        if(playStatus === "play"){
            document.querySelector('.play-container').style.border = "6px solid black";
            setPlayStatus("inactive")
            const x = document.getElementById("myAudio");
            x.pause(); 
            return
        }
        if(playStatus === "inactive"){
            document.querySelector('.play-container').style.border = "6px solid #4490C3";
            setPlayStatus("play")
            const x = document.getElementById("myAudio");
            x.play(); 
            return
        }

    };
    

    return (
        <div>
            <div style={{ display: 'flex', fontSize: '0.875em', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', width: '100%', marginTop: '1rem' }}>
                <div onClick={playBttn} className="audio-controls">
                    <div id="recordingContainer" className="play-container">
                        {!playStatus ? (
                            <img id="play" style={{ width: '21px'}} src={play} alt="Example" />
                        ) : null}
                        {playStatus === "inactive" ? (
                            <img id="play" style={{ width: '21px'}} src={play} alt="Example" />
                        ) : null}
                        {playStatus === "play" ? (
                            <img id="pause" style={{ width: '21px'}} src={pause} alt="Example" />
                        ) : null}
                        {/* {permission ? (
                        <div>
                            Done
                        </div>
                        ) : null} */}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default GuidedRelapse;